import { SystemState } from './types'

export const getContacts = (state: SystemState) => state.communication.contacts

export const getResidentContacts = (state: SystemState) =>
  state.communication.contacts.residents

export const getOtherContacts = (state: SystemState) =>
  state.communication.contacts.others

export const getBoardContacts = (state: SystemState) =>
  state.communication.contacts.boards
